var map = {
	"./promo-harry-in-hiding_00.jpg": 62,
	"./promo-harry-in-hiding_01.jpg": 5079,
	"./promo-harry-in-hiding_02.jpg": 61,
	"./promo-harry-in-hiding_03.jpg": 5080,
	"./promo-harry-in-hiding_04.jpg": 5081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5078;